import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PublicContentSection } from '../../../../../../../api/src/content-section/content-section.entity';
import { ContentSectionOpenEvent } from '../content-section.model';
import { PublicCreativeUnitPackageListing } from '../../../../../../../api/src/creative-unit-package-listing/creative-unit-package-listing.entity';
import { VisibilityConditionDto } from '../../../../../../../api/src/creative-unit-package/models/visibility-condition.dto';
import { Evaluate } from '../../../../../../../api/src/_core/utils/utils.evaluate';
import { MergeTags } from '../../../../../../../api/src/_core/utils/utils.merge-tags';
import { SelectedPartialListingEvent } from '../../../../pages/project/project.page';

@Component({
	selector: 'app-content-section-list',
	templateUrl: './content-section-list.component.html',
	styleUrls: ['./content-section-list.component.scss']
})
export class ContentSectionListComponent implements OnInit {
	@Input() contentSections: any[] = [];
	@Input() adminMode: boolean = false;
	@Input() contextState: any;
	@Input() enableNewCreativePackageRequests: boolean;

	@Output() openDialog: EventEmitter<ContentSectionOpenEvent> = new EventEmitter();
	@Output() delete: EventEmitter<PublicContentSection> = new EventEmitter();
	@Output() customEvent: EventEmitter<{ name: string; args: any[] }> = new EventEmitter();
	@Output() updateOrder: EventEmitter<{ contentSection: PublicContentSection; newOrder: number }> = new EventEmitter();

	@Output() selectedListing: EventEmitter<PublicCreativeUnitPackageListing> = new EventEmitter<PublicCreativeUnitPackageListing>();
	@Output() selectedPartialListing: EventEmitter<SelectedPartialListingEvent> = new EventEmitter<SelectedPartialListingEvent>();

	constructor() {}

	ngOnInit(): void {}

	evaluateConditions(conditions: VisibilityConditionDto[]) {
		let match = true;

		// If visibilityConditions are not an array, wrap into an array.
		if (!Array.isArray(conditions)) {
			conditions = [conditions];
		}

		// console.log('Evaluating visibility conditions', conditions, this.contextState);

		for (let condition of conditions) {
			// console.log('Checking visibility conditions', condition, CollectionUtils.isConditionValid(condition, state), state);

			// Apply merge tags to the condition.
			try {
				condition = JSON.parse(MergeTags.applyMergeTagsToString(JSON.stringify(condition), this.contextState));
			} catch (e) {
				console.warn('Unable to parse condition merge tags');
			}

			if (condition && !Evaluate.evaluate(condition, this.contextState)) {
				match = false;
			}
		}

		return match;
	}

	moveContentSection(contentSection: PublicContentSection, direction: 'up' | 'down') {
		const currentIndex = this.contentSections.findIndex(cs => cs.id === contentSection.id);
		if (currentIndex === -1) return;

		let newIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1;
		if (newIndex < 0 || newIndex >= this.contentSections.length) return;

		const targetSection = this.contentSections[newIndex];
		const newOrder = targetSection.order + (direction === 'up' ? -1 : 1);

		this.updateOrder.emit({ contentSection, newOrder });
	}
}
